import React from "react";
import { connect } from "react-redux";
import MatCheckbox from "../../components/common/Mat/MatCheckbox";
import { selectedChanged } from "../actions/resultsActions";

export default connect()(({ row, dispatch }) => {
    return (
        <MatCheckbox
            checked={row.selected}
            onChange={ev => {
                dispatch(selectedChanged(row._id, ev.target.checked));
            }}
        />
    );
});
